import React from 'react';
import { FiSend } from 'react-icons/fi';

const STATUS_COLORS = {
  draft: '#435654',
  sent: '#304849',
  opened: '#3e5c58',
  submitted: '#10b981',
  locked: '#435654',
  cancelled: '#ef4444'
};

function formatDate(value) {
  if (!value) return null;
  return new Date(value).toLocaleDateString(undefined, {
    month: 'short', day: 'numeric'
  });
}

export default function SelectionsCard({ selectionRequests, onManageClick }) {
  const isEmpty = !selectionRequests || selectionRequests.length === 0;

  return (
    <div className="ws-card">
      <div className="ws-card-header">
        <h4><FiSend size={15} /> Selections{!isEmpty && ` (${selectionRequests.length})`}</h4>
        {!isEmpty && (
          <button className="ws-card-action" onClick={onManageClick}>View All</button>
        )}
      </div>

      {isEmpty ? (
        <div className="ws-card-empty">
          <FiSend size={32} />
          <p>No selection requests yet</p>
          <button className="cta-btn" onClick={onManageClick}>Create Request</button>
        </div>
      ) : (
        <div className="ws-card-body">
          <div className="selections-list-compact">
            {selectionRequests.slice(0, 4).map(sr => (
              <div key={sr.id} className="selection-row-compact">
                <div className="selection-info">
                  <span className="selection-title">{sr.title || sr.gallery_title || 'Selection Request'}</span>
                  <span
                    className="status-pill"
                    style={{ '--pill-color': STATUS_COLORS[sr.status] || '#435654' }}
                  >
                    {sr.status}
                  </span>
                </div>
                <div className="selection-meta">
                  {sr.submission_count > 0 && (
                    <span>{sr.submission_count} submission{sr.submission_count !== 1 ? 's' : ''}</span>
                  )}
                  {sr.deadline && <span>Due {formatDate(sr.deadline)}</span>}
                </div>
              </div>
            ))}
          </div>
          {selectionRequests.length > 4 && (
            <button className="ws-card-action ws-card-footer-link" onClick={onManageClick}>
              +{selectionRequests.length - 4} more
            </button>
          )}
        </div>
      )}
    </div>
  );
}
